import { dataStarDash } from 'dls-icons-data'
import { createIcon } from '../common'

const IconStarDash = /*#__PURE__*/createIcon(dataStarDash)
export default IconStarDash
